import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-n-fieldset',
  templateUrl: './n-fieldset.component.html',
  styleUrls: ['./n-fieldset.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class NFieldsetComponent {
  icon = input<string>('');
  title = input.required<string>();
}
